/**
 * Number of rows displayed by default at each level of the advanced picker tree
 * @type {Number}
 */
export const ADV_TEAM_PICKER_INITIAL_VALUES = 8;

export default {
  ADV_TEAM_PICKER_INITIAL_VALUES
};
